import { Link2, KeyRound, Copy, RefreshCw, Ban } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const copy = (text) => navigator.clipboard?.writeText(text).then(() => toast.success("Copied")).catch(() => toast.error("Copy failed — select and copy manually"));

export function SharePanel({ team, onChange }) {
  const call = async (method, path, msg) => {
    try { const { data } = await api[method](`/teams/${team.id}/share/${path}`); onChange(data); toast.success(msg); } catch (e) { toast.error(errMsg(e)); }
  };
  const link = team.share?.invite_token ? `${window.location.origin}/join/${team.share.invite_token}` : null;
  const code = team.share?.access_code;
  return (
    <div className="space-y-5" data-testid="share-panel">
      <p className="text-sm text-slate-300">Players and parents get a <b>view-only</b> playbook. They can't change or delete plays. Nothing is public or searchable. Turn access off at any time.</p>
      <div className="card p-4 bg-[#0B1528]">
        <p className="label flex items-center gap-2"><Link2 size={14} />Private invite link</p>
        {link ? (
          <>
            <input readOnly value={link} className="input font-mono text-xs" onFocus={(e) => e.target.select()} data-testid="share-link-input" />
            <div className="flex flex-wrap gap-2 mt-3">
              <button className="btn btn-primary" onClick={() => copy(link)} data-testid="btn-copy-link"><Copy size={16} />Copy link</button>
              <button className="btn btn-ghost" onClick={() => call("post", "link", "New link created. The old link no longer works.")} data-testid="btn-new-link"><RefreshCw size={16} />New link</button>
              <button className="btn btn-danger" onClick={() => call("delete", "link", "Link turned off")} data-testid="btn-revoke-link"><Ban size={16} />Revoke link</button>
            </div>
          </>
        ) : <button className="btn btn-primary" onClick={() => call("post", "link", "Invite link created")} data-testid="btn-create-link"><Link2 size={16} />Create invite link</button>}
      </div>
      <div className="card p-4 bg-[#0B1528]">
        <p className="label flex items-center gap-2"><KeyRound size={14} />Team access code</p>
        {code ? (
          <>
            <p className="font-mono text-3xl font-bold tracking-[0.2em] text-[#FF8A1F]" data-testid="share-access-code">{code}</p>
            <p className="text-xs text-slate-400 mt-1">Players enter this at {window.location.origin}/join</p>
            <div className="flex flex-wrap gap-2 mt-3">
              <button className="btn btn-primary" onClick={() => copy(code)} data-testid="btn-copy-code"><Copy size={16} />Copy code</button>
              <button className="btn btn-ghost" onClick={() => call("post", "code", "New code created. The old code no longer works.")} data-testid="btn-rotate-code"><RefreshCw size={16} />Rotate code</button>
              <button className="btn btn-danger" onClick={() => call("delete", "code", "Code turned off")} data-testid="btn-disable-code"><Ban size={16} />Turn off</button>
            </div>
          </>
        ) : <button className="btn btn-primary" onClick={() => call("post", "code", "Access code created")} data-testid="btn-create-code"><KeyRound size={16} />Create access code</button>}
      </div>
    </div>
  );
}
